<div id="subnav-file-review" class="subnav flex-row flex-center-y" data-testid="subnav-file-review">
    <div class="header-content">
        <button class="back-button" data-testid="btn-back" (click)="onBack()" [attr.aria-label]="embedded ? 'Close separation review' : 'Back to pending reviews'">
            <svg *ngIf="!embedded" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="19" y1="12" x2="5" y2="12"></line>
                <polyline points="12 19 5 12 12 5"></polyline>
            </svg>
            <svg *ngIf="embedded" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
        </button>
        <div class="header-info">
            <h4>Review File Separation</h4>
            <p *ngIf="file_review_data" class="file-name">{{ file_review_data.file_name }}</p>
        </div>
    </div>
    <div *ngIf="file_review_data" class="approval-status" data-testid="approval-status">
        <button class="create-new-file-btn" (click)="onCreateNewFile()" [attr.data-testid]="'btn-create-file'">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            Create New File
        </button>
        <button class="reset-btn" (click)="onRevertDocumentStatus()" [attr.data-testid]="'btn-revert-process'">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"></path>
            </svg>
            Reset
        </button>
        <span class="approval-count">{{ file_review_data.approved_count }} of {{ file_review_data.total_count }} approved</span>
    </div>
</div>

<div *ngIf="isLoading" class="loading-indicator">
    <loading message="loading file review..."></loading>
</div>

<div *ngIf="!isLoading && !file_id" class="empty-state">
    <p class="empty-state-message">No file selected for review</p>
</div>

<div *ngIf="!isLoading && file_review_data" class="file-review-layout">
    <separated-files-sidebar [separated_documents]="file_review_data.separated_documents" [selected_doc_id]="selected_doc_id" [approved_count]="file_review_data.approved_count" [total_count]="file_review_data.total_count" (docSelected)="onDocumentSelected($event)">
    </separated-files-sidebar>

    <div class="vertical-divider"></div>

    <app-page-gallery [selected_document]="selected_document" [file_name]="file_review_data.file_name" [file_id]="file_id || ''" [allDocuments]="file_review_data.separated_documents" [fileStatus]="file_review_data.status" (approveDocument)="onApproveDocument($event)" (unapproveDocument)="onUnapproveDocument($event)" (reorderPages)="onReorderPages($event)" (movePageToDocument)="onMovePageToDocument($event)">
    </app-page-gallery>
</div>

<!-- Create File Modal -->
<app-create-file-modal *ngIf="showCreateFileModal" (closeModal)="onCloseCreateFileModal()" (createFile)="onCreateFileSubmit($event)">
</app-create-file-modal>